import React from "react";

const SideBarSmallLogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="26"
      viewBox="0 0 36 26"
      fill="none"
    >
      <path
        d="M16.6839 14.1063C16.6839 13.6141 17.0429 13.2238 17.7368 13.2238C18.4845 13.2238 18.9452 13.7101 18.9452 14.5986H23.7368C23.7368 10.8765 20.345 10 17.8265 10C14.4885 10 12 11.5189 12 13.9082C12 19.1492 19.2144 17.4022 19.2144 19.7556C19.2144 20.4039 18.658 20.7161 17.9641 20.7161C16.7378 20.7161 16.6241 19.8096 16.6241 19.4374H12.006C12.006 22.8593 15.015 24 17.9821 24C21.8644 24 24 22.5952 24 19.8396C23.994 15.199 16.6839 16.6938 16.6839 14.1063Z"
        fill="#7950FF"
      />
    </svg>
  );
};

export default SideBarSmallLogo;
